import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { bancosBrazil, bancosChile, bancosColombia, bancosEcuador, bancosMexico, bancosPeru } from '../../../const/bancos';
import { selectCurrency } from '../../../features/user/userSlice';
import { formatNumber } from '../../../utils/tools';
import { Button, ButtonsContainer, Form, InputContainer } from '../DepositElements';


const FormPayRetailers = ({form, handleChange, handleClose, solicitarRetiro, loading}) => {
  const [t] = useTranslation('global');
  const moneda = useSelector(selectCurrency);
  const [bancos, setBancos] = useState([]);

  useEffect(()=>{
    switch(moneda) {
      case '$':
        setBancos(bancosEcuador);
        break;
      case 'Sol':
        setBancos(bancosPeru);
        break;
      case 'MXN':
        form.tipoCuenta = '0001';
        setBancos(bancosMexico);
        break;
      case 'CLP':
        setBancos(bancosChile);
        break;
      case 'COP':
        setBancos(bancosColombia);
        break;
      case 'BRL':
        setBancos(bancosBrazil);
        break;
      default:
        break;
    }
  },[])

  return (
      <Form>
        <InputContainer>
          <label>{t('deposit.lbl-bank')}</label>
          <select value={form.nombreBanco} onChange={handleChange} name='nombreBanco' >
            <option disabled value=''>{t('deposit.input-bank')}</option>
            {bancos.map(item => <option key={item.id} value={`${item.nombre}_${item.id}`}>{item.nombre}</option>)}
          </select>
        </InputContainer>

        <InputContainer>
          <label>{t('deposit.name')}:</label>
          <input type='text' placeholder={t('deposit.name')} name='nombre' value={form.nombre} onChange={handleChange} />
        </InputContainer>

        <InputContainer>
          <label>{t('deposit.last-name')}:</label>
          <input type='text' placeholder={t('deposit.last-name')} name='apellido' value={form.apellido} onChange={handleChange} />
        </InputContainer>

        {moneda==='MXN' ?
        <InputContainer>
          <label>CLABE INTERBANCARIA:</label>
          <input type='text' placeholder='CLABE INTERBANCARIA' name='numeroCuenta' value={form.numeroCuenta} onChange={handleChange} />
        </InputContainer>
        :  <InputContainer>
        <label>{t("deposit.account-number")}:</label>
        <input type='text' placeholder={t("deposit.account-number")} name='numeroCuenta' value={form.numeroCuenta} onChange={handleChange} />
      </InputContainer>
      }

        {(moneda!=='BRL'&&moneda!=='CLP') &&
        <InputContainer>
          <label>NÚMERO AGENCIA:</label>
          <input type='text' placeholder='NUMERO AGENCIA BANCARIA' name='numeroAgencia' value={form.numeroAgencia} onChange={handleChange} />
        </InputContainer>
	}

        {moneda!=='MXN' &&
        <InputContainer>
          <label>{t("deposit.account-type")}:</label>
          <select value={form.tipoCuenta} onChange={handleChange} name='tipoCuenta' >
            <option disabled value=''>{t("deposit.select-account-type")}</option>
            {moneda==='BRL' &&
            <>
              <option value='0001'>Poupança</option>
              <option value='0002'>Conta Corrente</option>
            </>
            }

          {moneda==='CLP' &&
            <>
              <option value='0001'>Cuenta Corriente / Cuenta Vista</option>
              <option value='0004'>Cuenta RUT</option>
            </>
          }
          {(moneda==='COP'||moneda==='$'||moneda==='Sol') &&
            <>
              <option value='0001'>Cuenta Ahorro</option>
              <option value='0002'>Cuenta Corriente</option>
            </>
          }
          </select>
        </InputContainer>
        }

        <InputContainer>
          <label>{t("deposit.id")}:</label>
          <input type='text' placeholder={t("deposit.id")} name='cedula' value={form.cedula} onChange={handleChange} />
        </InputContainer>

        {moneda==='CLP' &&
        <InputContainer>
          <label>TIPO BENEFICIARIO</label>
          <select value={form.tipoBeneficiario} onChange={handleChange} name='tipoBeneficiario' >
            <option disabled value=''>SELECCIONE EL TIPO DE BENEFICIARIO</option>
            <option value='person'>PERSONA</option>
            <option value='company'>COMPAÑÍA</option>
          </select>
        </InputContainer>
        }

        <InputContainer>
          <label>{t("deposit.email")}:</label>
          <input type='text' placeholder={t("deposit.email")} name='email' value={form.email} onChange={handleChange} />
        </InputContainer>

        {(moneda==='$'||moneda==='Sol') && <>

        <InputContainer>
          <label>{t("deposit.phone")}:</label>
          <input type='text' placeholder={t("deposit.phone")} name='telefono' value={form.telefono} onChange={handleChange} />
        </InputContainer>

        <InputContainer>
          <label>{t("deposit.city")}:</label>
          <input type='text' placeholder={t("deposit.city")} name='ciudad' value={form.ciudad} onChange={handleChange} />
        </InputContainer>

        <InputContainer>
          <label>{t("deposit.address")}:</label>
          <input type='text' placeholder={t("deposit.address")} name='direccion' value={form.direccion} onChange={handleChange} />
        </InputContainer>
        </>}


        <InputContainer>
          <label>{t('deposit.lbl-amount')}</label>
          <input type='text' placeholder='0,00' name='monto2' value={form.monto2} onChange={(e)=>handleChange(formatNumber(e))}/>
        </InputContainer>

      <ButtonsContainer>
        <Button
          onClick={(e) => {
            e.preventDefault();
            handleClose();
          }}
        >
          {t("deposit.btn-cancel")}
        </Button>
        <Button
          primary={true}
          onClick={solicitarRetiro}
        >
          {loading ? t("deposit.loading") : t("deposit.btn-confirm")}
        </Button>
      </ButtonsContainer>
      </Form>
  )
}

export default FormPayRetailers